import { Link } from 'react-router-dom';

export default function SharedFooter() {
  return (
    <footer className="bg-gradient-to-br from-[#1a1a1a] via-[#0f0f0f] to-black text-white relative overflow-hidden">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo + Tagline + Rating */}
          <div>
            <Link to="/">
              <img 
                src="https://static.readdy.ai/image/1e14a9881218f497bbf78ac6a19724bb/ff4ec48df95ab1022488835e6aca3751.png" 
                alt="Urban Connect Logo" 
                className="h-14 w-auto mb-6 bg-white rounded-lg p-2"
              />
            </Link>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed">
              Your trusted partner for professional data and electrical services across Sydney. Over 15 years of experience delivering quality workmanship with a lifetime guarantee.
            </p>
            <div className="flex items-center gap-2 mb-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-[#f67f19] text-lg"></i>
              ))}
            </div>
            <a
              href="https://www.google.com/maps/place/Urban+Connect/@-33.8464886,150.2725555,9z/data=!4m12!1m2!2m1!1surban+connect!3m8!1s0x8258cbd3dee1b115:0xb0c8b0948efd27c6!8m2!3d-33.8482439!4d150.9319747!9m1!1b1!15sCg11cmJhbiBjb25uZWN0kgELZWxlY3RyaWNpYW7gAQA!16s%2Fg%2F11q43j0gts?entry=ttu&g_ep=EgoyMDI2MDMwOS4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-sm font-bold text-white hover:text-[#f67f19] transition-colors cursor-pointer"
            >
              5.0 Google Rating
            </a>
            <p className="text-xs text-gray-500 mt-1">Based on 150+ reviews</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/"
                  className="text-gray-400 hover:text-[#f67f19] transition-colors text-sm cursor-pointer flex items-center gap-2 group"
                >
                  <i className="ri-arrow-right-s-line text-[#f67f19] opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/about"
                  className="text-gray-400 hover:text-[#f67f19] transition-colors text-sm cursor-pointer flex items-center gap-2 group"
                >
                  <i className="ri-arrow-right-s-line text-[#f67f19] opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/services"
                  className="text-gray-400 hover:text-[#f67f19] transition-colors text-sm cursor-pointer flex items-center gap-2 group"
                >
                  <i className="ri-arrow-right-s-line text-[#f67f19] opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact"
                  className="text-gray-400 hover:text-[#f67f19] transition-colors text-sm cursor-pointer flex items-center gap-2 group"
                >
                  <i className="ri-arrow-right-s-line text-[#f67f19] opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Contact
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact"
                  className="text-gray-400 hover:text-[#f67f19] transition-colors text-sm cursor-pointer flex items-center gap-2 group"
                >
                  <i className="ri-arrow-right-s-line text-[#f67f19] opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Book Online
                </Link>
              </li>
            </ul>
          </div>

          {/* Services List */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Our Services</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>
                <Link to="/services/emergency-work" className="hover:text-[#f67f19] transition-colors cursor-pointer">
                  Emergency Work
                </Link>
              </li>
              <li>
                <Link to="/services/ceiling-fans" className="hover:text-[#f67f19] transition-colors cursor-pointer">
                  Ceiling Fans
                </Link>
              </li>
              <li>
                <Link to="/services/power-points" className="hover:text-[#f67f19] transition-colors cursor-pointer">
                  Power Points
                </Link>
              </li>
              <li>
                <Link to="/services/fault-detection" className="hover:text-[#f67f19] transition-colors cursor-pointer">
                  Fault Detection
                </Link>
              </li>
              <li>
                <Link to="/services/smoke-alarms" className="hover:text-[#f67f19] transition-colors cursor-pointer">
                  Smoke Alarms
                </Link>
              </li>
              <li>
                <Link to="/services/lighting" className="hover:text-[#f67f19] transition-colors cursor-pointer">
                  Lighting Solutions
                </Link>
              </li>
              <li>
                <Link to="/services/electrical-repairs" className="hover:text-[#f67f19] transition-colors cursor-pointer">
                  Electrical Repairs
                </Link>
              </li>
              <li>
                <Link to="/services/solar-batteries" className="hover:text-[#f67f19] transition-colors cursor-pointer">
                  Solar Batteries
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Contact Us</h4>
            <div className="space-y-5">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#f67f19]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-fill text-[#f67f19] text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1 uppercase tracking-wide">Call Us</div>
                  <a href="tel:0416497716" className="text-white hover:text-[#f67f19] transition-colors font-bold text-lg cursor-pointer">
                    0416 497 716
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#f67f19]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-fill text-[#f67f19] text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1 uppercase tracking-wide">Email Us</div>
                  <a href="mailto:urbanconnect@mail.com" className="text-white hover:text-[#f67f19] transition-colors font-semibold cursor-pointer break-all">
                    urbanconnect@mail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#f67f19]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-fill text-[#f67f19] text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1 uppercase tracking-wide">Find Us</div>
                  <a
                    href="https://www.google.com/maps/place/Urban+Connect/@-33.8464886,150.2725555,9z/data=!4m12!1m2!2m1!1surban+connect!3m8!1s0x8258cbd3dee1b115:0xb0c8b0948efd27c6!8m2!3d-33.8482439!4d150.9319747!9m1!1b1!15sCg11cmJhbiBjb25uZWN0kgELZWxlY3RyaWNpYW7gAQA!16s%2Fg%2F11q43j0gts?entry=ttu&g_ep=EgoyMDI2MDMwOS4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-white hover:text-[#f67f19] transition-colors font-semibold text-sm cursor-pointer flex items-center gap-1"
                  >
                    View on Google Maps
                    <i className="ri-external-link-line text-xs"></i>
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#f67f19]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-fill text-[#f67f19] text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-1 uppercase tracking-wide">Business Hours</div>
                  <div className="text-white text-sm font-semibold">
                    Mon-Fri: 7AM-6PM<br />
                    <span className="text-[#f67f19]">24/7 Emergency</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col md:flex-row items-center gap-4">
              <p className="text-sm text-gray-400">
                © 2026 Urban Connect. All rights reserved.
              </p>
              <div className="flex items-center gap-2 bg-[#f67f19]/10 px-4 py-2 rounded-full">
                <i className="ri-shield-check-fill text-[#f67f19]"></i>
                <span className="text-xs font-bold text-white">Licensed &amp; Insured Electricians</span>
              </div>
            </div>
            <a
              href="https://www.instagram.com/urban_connect_electrical/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-[#f67f19]/10 hover:bg-[#f67f19] transition-colors cursor-pointer group"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-[#f67f19] group-hover:text-white text-xl transition-colors"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}